import React, { SVGProps } from 'react'

import { IconTemplateIPortIcon } from '@/shared/lib/@deprecated/iport-icons/template/IconTemplateIPortIcon'
import { CustomIconProps } from '@/shared/ui/icon-template'

export const SvgWallet = (props: SVGProps<SVGSVGElement> & CustomIconProps) => {
	return (
		<IconTemplateIPortIcon height={50} width={32} {...props}>
			<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
				<g id="wallet">
					<path
						id="Vector 126"
						d="M4 26V7C4 5.34315 5.34315 4 7 4H24V26C24 27.1046 23.1046 28 22 28H6C4.89543 28 4 27.1046 4 26Z"
						fill="url(#paint0_linear_13639_60420)"
					/>
					<path
						id="Vector 125"
						d="M4 28V11C4 9.34315 5.34315 8 7 8H26C27.1046 8 28 8.89543 28 10V26C28 27.1046 27.1046 28 26 28H4Z"
						fill="#545563"
					/>
					<path
						id="Union"
						d="M23.332 16C24.4366 16 25.332 16.8954 25.332 18C25.332 19.1046 24.4366 20 23.332 20C22.2275 20 21.332 19.1046 21.332 18C21.332 16.8954 22.2275 16 23.332 16Z"
						fill="white"
					/>
				</g>
				<defs>
					<linearGradient
						id="paint0_linear_13639_60420"
						x1="3.00002"
						y1="29.3333"
						x2="3.00002"
						y2="2.66667"
						gradientUnits="userSpaceOnUse">
						<stop stopColor="#5C90FC" />
						<stop offset="1" stopColor="#B7D2FF" />
					</linearGradient>
				</defs>
			</svg>
		</IconTemplateIPortIcon>
	)
}
